import { bytesToFileSizeString } from '@lbcamden/shared-utils';
import { AxiosError } from 'axios';

import { maxUploadFileSize } from '~/common/config/constants';
import { PcfraActivityType } from '~/common/types/pcfra';
import { RpeepStatus } from '~/common/types/people';

export const selfReferralActivityTypes: PcfraActivityType[] = [
  'self-referral-accepted',
  'self-referral-rejected',
];

export const rpeepActivityTypes: PcfraActivityType[] = ['rpeep-completed', 'rpeep-revoked'];

export const activityTypeRpeepStatusMap: Partial<Record<PcfraActivityType, RpeepStatus>> = {
  'rpeep-completed': RpeepStatus.Active,
  'rpeep-revoked': RpeepStatus.Revoked,
};

export const getUploadErrorMessage = (error: unknown) => {
  if (error instanceof AxiosError) {
    const { status, data } = error.response || {};

    if (status === 413) {
      return `The size of the file exceeds the ${bytesToFileSizeString(maxUploadFileSize)} limit.`;
    }

    if (typeof data?.error === 'string') {
      return data.error;
    }
  }
  return 'An error occurred';
};
